var map = {
	"./animal-crossing-logo-700px.png": "e8a5",
	"./animal-crossing-logo-high-def.png": "ee45",
	"./bugs/icon/agriasbutterfly.png": "4f78",
	"./bugs/icon/ant.png": "bb56",
	"./bugs/icon/atlasmoth.png": "9d61",
	"./bugs/icon/bagworm.png": "23f8",
	"./bugs/icon/bandeddragonfly.png": "2dd3",
	"./bugs/icon/bellcricket.png": "2d4d",
	"./bugs/icon/blueweevilbeetle.png": "405a",
	"./bugs/icon/browncicada.png": "ea19",
	"./bugs/icon/centipede.png": "39e1",
	"./bugs/icon/cicadashell.png": "9c72",
	"./bugs/icon/citruslonghornedbeetle.png": "9bad",
	"./bugs/icon/commonbluebottle.png": "57ae",
	"./bugs/icon/commonbutterfly.png": "b677",
	"./bugs/icon/cricket.png": "1b82",
	"./bugs/icon/cyclommatusstag.png": "733d",
	"./bugs/icon/damselfly.png": "8638",
	"./bugs/icon/darnerdragonfly.png": "f2b1",
	"./bugs/icon/divingbeetle.png": "5a74",
	"./bugs/icon/dronebeetle.png": "040c",
	"./bugs/icon/dungbeetle.png": "d361",
	"./bugs/icon/earthboringdungbeetle.png": "e78e",
	"./bugs/icon/emperorbutterfly.png": "4811",
	"./bugs/icon/eveningcicada.png": "fff1",
	"./bugs/icon/firefly.png": "10ae",
	"./bugs/icon/flea.png": "8bb5",
	"./bugs/icon/fly.png": "07c3",
	"./bugs/icon/giantcicada.png": "fa49",
	"./bugs/icon/giantstag.png": "699e",
	"./bugs/icon/giantwaterbug.png": "4dec",
	"./bugs/icon/giraffestag.png": "d085",
	"./bugs/icon/goldenstag.png": "3565",
	"./bugs/icon/goliathbeetle.png": "1358",
	"./bugs/icon/grasshopper.png": "a128",
	"./bugs/icon/greatpurpleemperor.png": "3ecf",
	"./bugs/icon/hermitcrab.png": "2cbd",
	"./bugs/icon/honeybee.png": "9f85",
	"./bugs/icon/hornedatlas.png": "7514",
	"./bugs/icon/horneddynastid.png": "2994",
	"./bugs/icon/hornedelephant.png": "c7a7",
	"./bugs/icon/hornedhercules.png": "f3c2",
	"./bugs/icon/jewelbeetle.png": "3b85",
	"./bugs/icon/ladybug.png": "9420",
	"./bugs/icon/longlocust.png": "b3eb",
	"./bugs/icon/madagascansunsetmoth.png": "4468",
	"./bugs/icon/manfacedstinkbug.png": "4f3c",
	"./bugs/icon/mantis.png": "74e9",
	"./bugs/icon/migratorylocust.png": "e4c6",
	"./bugs/icon/miyamastag.png": "d2d4",
	"./bugs/icon/molecricket.png": "662a",
	"./bugs/icon/monarchbutterfly.png": "ccc7",
	"./bugs/icon/mosquito.png": "fea2",
	"./bugs/icon/moth.png": "e62d",
	"./bugs/icon/orchidmantis.png": "fc54",
	"./bugs/icon/paperkitebutterfly.png": "b21b",
	"./bugs/icon/peacockbutterfly.png": "7000",
	"./bugs/icon/pillbug.png": "7834",
	"./bugs/icon/pondskater.png": "4817",
	"./bugs/icon/queenalexandrasbirdwing.png": "a255",
	"./bugs/icon/rainbowstag.png": "82f4",
	"./bugs/icon/rajahbrookesbirdwing.png": "2eba",
	"./bugs/icon/reddragonfly.png": "5594",
	"./bugs/icon/rename": "3279",
	"./bugs/icon/rename.js": "3279",
	"./bugs/icon/ricegrasshopper.png": "1b6d",
	"./bugs/icon/robustcicada.png": "34f2",
	"./bugs/icon/rosaliabatesibeetle.png": "0aff",
	"./bugs/icon/sawstag.png": "b185",
	"./bugs/icon/scarabbeetle.png": "c066",
	"./bugs/icon/scorpion.png": "caa7",
	"./bugs/icon/snail.png": "2fdd",
	"./bugs/icon/spider.png": "e843",
	"./bugs/icon/stinkbug.png": "93b5",
	"./bugs/icon/tarantula.png": "4c7c",
	"./bugs/icon/tigerbeetle.png": "7bc2",
	"./bugs/icon/tigerbutterfly.png": "1b4d",
	"./bugs/icon/violinbeetle.png": "b11e",
	"./bugs/icon/walkercicada.png": "fd8b",
	"./bugs/icon/walkingleaf.png": "d126",
	"./bugs/icon/walkingstick.png": "f3ad",
	"./bugs/icon/wasp.png": "d480",
	"./bugs/icon/wharfroach.png": "c99c",
	"./bugs/icon/yellowbutterfly.png": "f3cb",
	"./deepSeaCreatures/icon/abalone.png": "3474",
	"./deepSeaCreatures/icon/acorn_barnicle.png": "a947",
	"./deepSeaCreatures/icon/chambered_nautilus.png": "9a6e",
	"./deepSeaCreatures/icon/dungeoness_crab.png": "8761",
	"./deepSeaCreatures/icon/firefly_squid.png": "42fa",
	"./deepSeaCreatures/icon/flatworm.png": "122e",
	"./deepSeaCreatures/icon/gazami_crab.png": "616f",
	"./deepSeaCreatures/icon/giant_isopod.png": "dd27",
	"./deepSeaCreatures/icon/gigas_giant_clam.png": "f1c4",
	"./deepSeaCreatures/icon/horseshoe_crab.png": "81bc",
	"./deepSeaCreatures/icon/lobster.png": "24db",
	"./deepSeaCreatures/icon/mantis_shrimp.png": "3963",
	"./deepSeaCreatures/icon/moon_jellyfish.png": "b9f8",
	"./deepSeaCreatures/icon/mussel.png": "224c",
	"./deepSeaCreatures/icon/octopus.png": "66dc",
	"./deepSeaCreatures/icon/oyster.png": "320a",
	"./deepSeaCreatures/icon/pearl_oyster.png": "82b9",
	"./deepSeaCreatures/icon/red_king_crab.png": "277b",
	"./deepSeaCreatures/icon/scallop.png": "887b",
	"./deepSeaCreatures/icon/sea_anemone.png": "c51a",
	"./deepSeaCreatures/icon/sea_cucumber.png": "5ddc",
	"./deepSeaCreatures/icon/sea_grapes.png": "e885",
	"./deepSeaCreatures/icon/sea_pig.png": "a27b",
	"./deepSeaCreatures/icon/sea_pineapple.png": "fdc9",
	"./deepSeaCreatures/icon/sea_slug.png": "1db1",
	"./deepSeaCreatures/icon/sea_star.png": "da85",
	"./deepSeaCreatures/icon/sea_urchin.png": "5677",
	"./deepSeaCreatures/icon/seaweed.png": "f591",
	"./deepSeaCreatures/icon/slate_pencil_urchin.png": "b625",
	"./deepSeaCreatures/icon/snow_crab.png": "b76d",
	"./deepSeaCreatures/icon/spider_crab.png": "ac8c",
	"./deepSeaCreatures/icon/spiny_lobster.png": "8ddd",
	"./deepSeaCreatures/icon/spotted_garden_eel.png": "7821",
	"./deepSeaCreatures/icon/sweet_shrimp.png": "f082",
	"./deepSeaCreatures/icon/tiger_prawn.png": "e222",
	"./deepSeaCreatures/icon/turban_shell.png": "5d8d",
	"./deepSeaCreatures/icon/umbrella_octopus.png": "a8ca",
	"./deepSeaCreatures/icon/vampire_squid.png": "aeb3",
	"./deepSeaCreatures/icon/venus_flower_basket.png": "6cee",
	"./deepSeaCreatures/icon/whelk.png": "915d",
	"./feather/activity.svg": "24e2",
	"./feather/airplay.svg": "bd68",
	"./feather/alert-circle.svg": "1c7b",
	"./feather/alert-octagon.svg": "4135",
	"./feather/alert-triangle.svg": "adcd",
	"./feather/align-center.svg": "5c75",
	"./feather/align-justify.svg": "f610",
	"./feather/align-left.svg": "8128",
	"./feather/align-right.svg": "6e83",
	"./feather/anchor.svg": "fd2b",
	"./feather/aperture.svg": "ceb1",
	"./feather/archive.svg": "7fa2",
	"./feather/arrow-down-circle.svg": "d475",
	"./feather/arrow-down-left.svg": "585a",
	"./feather/arrow-down-right.svg": "d51e",
	"./feather/arrow-down.svg": "03dc",
	"./feather/arrow-left-circle.svg": "926b",
	"./feather/arrow-left.svg": "b38a",
	"./feather/arrow-right-circle.svg": "0b20",
	"./feather/arrow-right.svg": "1274",
	"./feather/arrow-up-circle.svg": "d7c7",
	"./feather/arrow-up-left.svg": "aa6b",
	"./feather/arrow-up-right.svg": "355f",
	"./feather/arrow-up.svg": "88fc",
	"./feather/at-sign.svg": "a339",
	"./feather/award.svg": "dc9a",
	"./feather/bar-chart-2.svg": "3b14",
	"./feather/bar-chart.svg": "aba2",
	"./feather/battery-charging.svg": "e2a5",
	"./feather/battery.svg": "e77c",
	"./feather/bell-off.svg": "56ab",
	"./feather/bell.svg": "c883",
	"./feather/bluetooth.svg": "4c80",
	"./feather/bold.svg": "533d",
	"./feather/book-open.svg": "3d27",
	"./feather/book.svg": "ca09",
	"./feather/bookmark.svg": "16a3",
	"./feather/box.svg": "e9eb",
	"./feather/briefcase.svg": "2718",
	"./feather/calendar.svg": "308a",
	"./feather/camera-off.svg": "864d",
	"./feather/camera.svg": "d65e",
	"./feather/cast.svg": "9ca2",
	"./feather/check-circle.svg": "9ef6",
	"./feather/check-square.svg": "6a52",
	"./feather/check.svg": "565c",
	"./feather/chevron-down.svg": "8914",
	"./feather/chevron-left.svg": "9cd1",
	"./feather/chevron-right.svg": "6cee9",
	"./feather/chevron-up.svg": "894c",
	"./feather/chevrons-down.svg": "86d2",
	"./feather/chevrons-left.svg": "6451",
	"./feather/chevrons-right.svg": "1c4e",
	"./feather/chevrons-up.svg": "8740",
	"./feather/chrome.svg": "3d0f",
	"./feather/circle.svg": "fc55",
	"./feather/clipboard.svg": "8648",
	"./feather/clock.svg": "3dfd",
	"./feather/cloud-drizzle.svg": "4b37",
	"./feather/cloud-lightning.svg": "11e7",
	"./feather/cloud-off.svg": "1a12",
	"./feather/cloud-rain.svg": "7276",
	"./feather/cloud-snow.svg": "e946",
	"./feather/cloud.svg": "f4c3",
	"./feather/code.svg": "7a16",
	"./feather/codepen.svg": "5db7",
	"./feather/command.svg": "dbc6",
	"./feather/compass.svg": "3f10",
	"./feather/copy.svg": "16a6",
	"./feather/corner-down-left.svg": "f807",
	"./feather/corner-down-right.svg": "d364",
	"./feather/corner-left-down.svg": "2f98",
	"./feather/corner-left-up.svg": "0a8d",
	"./feather/corner-right-down.svg": "9556",
	"./feather/corner-right-up.svg": "63ba",
	"./feather/corner-up-left.svg": "f56b",
	"./feather/corner-up-right.svg": "683d",
	"./feather/cpu.svg": "02ed",
	"./feather/credit-card.svg": "8ff8",
	"./feather/crop.svg": "f386",
	"./feather/crosshair.svg": "570e",
	"./feather/database.svg": "3b70",
	"./feather/delete.svg": "cb54",
	"./feather/disc.svg": "25eb",
	"./feather/dollar-sign.svg": "e61f",
	"./feather/download-cloud.svg": "90a3",
	"./feather/download.svg": "7c9f",
	"./feather/droplet.svg": "c835",
	"./feather/edit-2.svg": "3479",
	"./feather/edit-3.svg": "06e5",
	"./feather/edit.svg": "26cb",
	"./feather/external-link.svg": "cae6",
	"./feather/eye-off.svg": "b285",
	"./feather/eye.svg": "72fa",
	"./feather/facebook.svg": "4d98",
	"./feather/fast-forward.svg": "360d",
	"./feather/feather.svg": "06b0",
	"./feather/file-minus.svg": "26d0",
	"./feather/file-plus.svg": "4210",
	"./feather/file-text.svg": "0335",
	"./feather/file.svg": "5542",
	"./feather/film.svg": "528d",
	"./feather/filter.svg": "b9c2",
	"./feather/flag.svg": "3de7",
	"./feather/folder-minus.svg": "8773",
	"./feather/folder-plus.svg": "ab59",
	"./feather/folder.svg": "5827",
	"./feather/gift.svg": "e058",
	"./feather/git-branch.svg": "e44d",
	"./feather/git-commit.svg": "3c96",
	"./feather/git-merge.svg": "9290",
	"./feather/git-pull-request.svg": "8cf6",
	"./feather/github.svg": "c7a3",
	"./feather/gitlab.svg": "f211",
	"./feather/globe.svg": "e2b1",
	"./feather/grid.svg": "a587",
	"./feather/hard-drive.svg": "dfe1",
	"./feather/hash.svg": "e437",
	"./feather/headphones.svg": "08a8",
	"./feather/heart.svg": "8b53",
	"./feather/help-circle.svg": "e4e7",
	"./feather/home.svg": "dd83",
	"./feather/image.svg": "1dae",
	"./feather/inbox.svg": "ea60",
	"./feather/info.svg": "94ac",
	"./feather/instagram.svg": "b051",
	"./feather/italic.svg": "13e3",
	"./feather/layers.svg": "1e17",
	"./feather/layout.svg": "0bc8",
	"./feather/life-buoy.svg": "a4cd",
	"./feather/link-2.svg": "f644",
	"./feather/link.svg": "dd7d",
	"./feather/linkedin.svg": "ecd2",
	"./feather/list.svg": "59f0",
	"./feather/loader.svg": "de7e",
	"./feather/lock.svg": "6406",
	"./feather/log-in.svg": "4ff2",
	"./feather/log-out.svg": "707a",
	"./feather/mail.svg": "248b",
	"./feather/map-pin.svg": "f13b",
	"./feather/map.svg": "7f7c",
	"./feather/maximize-2.svg": "1741",
	"./feather/maximize.svg": "e851",
	"./feather/menu.svg": "8cce",
	"./feather/message-circle.svg": "e96e",
	"./feather/message-square.svg": "edcc",
	"./feather/mic-off.svg": "dddd",
	"./feather/mic.svg": "9dab",
	"./feather/minimize-2.svg": "0b70",
	"./feather/minimize.svg": "1c59",
	"./feather/minus-circle.svg": "f320",
	"./feather/minus-square.svg": "9434",
	"./feather/minus.svg": "8f5c",
	"./feather/monitor.svg": "149e",
	"./feather/moon.svg": "566a",
	"./feather/more-horizontal.svg": "d7d2",
	"./feather/more-vertical.svg": "669b",
	"./feather/move.svg": "2211",
	"./feather/music.svg": "84cf",
	"./feather/navigation-2.svg": "3543",
	"./feather/navigation.svg": "db06",
	"./feather/octagon.svg": "1d8b",
	"./feather/package.svg": "9668",
	"./feather/paperclip.svg": "de4c",
	"./feather/pause-circle.svg": "a319",
	"./feather/pause.svg": "0436",
	"./feather/percent.svg": "9306",
	"./feather/phone-call.svg": "9fcd",
	"./feather/phone-forwarded.svg": "8684",
	"./feather/phone-incoming.svg": "9695",
	"./feather/phone-missed.svg": "33f3",
	"./feather/phone-off.svg": "f93e",
	"./feather/phone-outgoing.svg": "b171",
	"./feather/phone.svg": "2f44",
	"./feather/pie-chart.svg": "b43b",
	"./feather/play-circle.svg": "ed56",
	"./feather/play.svg": "fa4c",
	"./feather/plus-circle.svg": "1782",
	"./feather/plus-square.svg": "f5b9",
	"./feather/plus.svg": "ac09",
	"./feather/pocket.svg": "b053",
	"./feather/power.svg": "55f3",
	"./feather/printer.svg": "b0b2",
	"./feather/radio.svg": "91c8",
	"./feather/refresh-ccw.svg": "50a7",
	"./feather/refresh-cw.svg": "5a28",
	"./feather/repeat.svg": "43b6",
	"./feather/rewind.svg": "3dc6",
	"./feather/rotate-ccw.svg": "20eb",
	"./feather/rotate-cw.svg": "a92e",
	"./feather/rss.svg": "ed53",
	"./feather/save.svg": "3f16",
	"./feather/scissors.svg": "1fca",
	"./feather/search.svg": "2d32",
	"./feather/send.svg": "3e6d",
	"./feather/server.svg": "2c24",
	"./feather/settings.svg": "6e91",
	"./feather/share-2.svg": "312a",
	"./feather/share.svg": "135c",
	"./feather/shield-off.svg": "12f2",
	"./feather/shield.svg": "4a01",
	"./feather/shopping-bag.svg": "8249",
	"./feather/shopping-cart.svg": "27ca",
	"./feather/shuffle.svg": "2107",
	"./feather/sidebar.svg": "172f",
	"./feather/skip-back.svg": "aafa",
	"./feather/skip-forward.svg": "dc90",
	"./feather/slack.svg": "6cb3",
	"./feather/slash.svg": "4c0c",
	"./feather/sliders.svg": "afa1",
	"./feather/smartphone.svg": "f088",
	"./feather/speaker.svg": "bc13",
	"./feather/square.svg": "ceec",
	"./feather/star-default.svg": "be13",
	"./feather/star-hover.svg": "e8f1",
	"./feather/star.svg": "e6b1",
	"./feather/stop-circle.svg": "b654",
	"./feather/sun.svg": "def4",
	"./feather/sunrise.svg": "4d44",
	"./feather/sunset.svg": "029c",
	"./feather/tablet.svg": "f98e",
	"./feather/tag.svg": "9ff7",
	"./feather/target.svg": "cccd",
	"./feather/terminal.svg": "0086",
	"./feather/thermometer.svg": "d3f1",
	"./feather/thumbs-down.svg": "42e9",
	"./feather/thumbs-up.svg": "3e2a",
	"./feather/toggle-left.svg": "e71e",
	"./feather/toggle-right.svg": "c561",
	"./feather/trash-2.svg": "29fe",
	"./feather/trash.svg": "53e3",
	"./feather/trending-down.svg": "764d",
	"./feather/trending-up.svg": "292c",
	"./feather/triangle.svg": "0a7e",
	"./feather/truck.svg": "0777",
	"./feather/tv.svg": "ffda",
	"./feather/twitter.svg": "78ac",
	"./feather/type.svg": "8ff7",
	"./feather/umbrella.svg": "fce6",
	"./feather/underline.svg": "e3a4",
	"./feather/unlock.svg": "f46b",
	"./feather/upload-cloud.svg": "b385",
	"./feather/upload.svg": "49bf",
	"./feather/user-check.svg": "4887",
	"./feather/user-minus.svg": "8a5e",
	"./feather/user-plus.svg": "a7ec",
	"./feather/user-x.svg": "1ce5",
	"./feather/user.svg": "cfad",
	"./feather/users.svg": "2f25",
	"./feather/video-off.svg": "69bd",
	"./feather/video.svg": "e39e",
	"./feather/voicemail.svg": "2a9b",
	"./feather/volume-1.svg": "9890",
	"./feather/volume-2.svg": "eada",
	"./feather/volume-x.svg": "8c31",
	"./feather/volume.svg": "fb5a",
	"./feather/watch.svg": "4520",
	"./feather/wifi-off.svg": "4a3d",
	"./feather/wifi.svg": "9d9b",
	"./feather/wind.svg": "39e2",
	"./feather/x-circle.svg": "dcef",
	"./feather/x-square-alert.svg": "2552",
	"./feather/x-square.svg": "789b",
	"./feather/x.svg": "6405",
	"./feather/youtube.svg": "1808",
	"./feather/zap-off.svg": "09d1",
	"./feather/zap.svg": "fd80",
	"./feather/zoom-in.svg": "4ca9",
	"./feather/zoom-out.svg": "44ff",
	"./fishes/actual/anchovy.png": "101b",
	"./fishes/actual/angelfish.png": "ec02",
	"./fishes/actual/arapaima.png": "ab50",
	"./fishes/actual/arowana.png": "14bd",
	"./fishes/actual/barredknifejaw.png": "808c",
	"./fishes/actual/barreleye.png": "8897",
	"./fishes/actual/betta.png": "a528",
	"./fishes/actual/bitterling.png": "47b7",
	"./fishes/actual/blackbass.png": "bb3d",
	"./fishes/actual/blowfish.png": "9ef9",
	"./fishes/actual/bluegill.png": "7cce",
	"./fishes/actual/bluemarlin.png": "30fb",
	"./fishes/actual/butterflyfish.png": "f06d",
	"./fishes/actual/carp.png": "100a",
	"./fishes/actual/catfish.png": "2086",
	"./fishes/actual/char.png": "6401",
	"./fishes/actual/cherrysalmon.png": "23ba",
	"./fishes/actual/clownfish.png": "2730",
	"./fishes/actual/coelacanth.png": "62d1",
	"./fishes/actual/crawfish.png": "c081",
	"./fishes/actual/cruciancarp.png": "2851",
	"./fishes/actual/dab.png": "d3cc",
	"./fishes/actual/dace.png": "eb0d",
	"./fishes/actual/footballfish.png": "a697",
	"./fishes/actual/freshwatergoby.png": "34c6",
	"./fishes/actual/frog.png": "a578",
	"./fishes/actual/gar.png": "d6f5",
	"./fishes/actual/giantsnakehead.png": "3635",
	"./fishes/actual/gianttrevally.png": "1785",
	"./fishes/actual/goldentrout.png": "407c",
	"./fishes/actual/goldfish.png": "7920",
	"./fishes/actual/greatwhiteshark.png": "9b10",
	"./fishes/actual/guppy.png": "9b88",
	"./fishes/actual/hammerheadshark.png": "ccb2",
	"./fishes/actual/horsemackerel.png": "eb08",
	"./fishes/actual/killifish.png": "5330",
	"./fishes/actual/kingsalmon.png": "4bc7",
	"./fishes/actual/koi.png": "5a81",
	"./fishes/actual/loach.png": "1eb9",
	"./fishes/actual/mahimahi.png": "61b1",
	"./fishes/actual/mittencrab.png": "e844",
	"./fishes/actual/morayeel.png": "2e2b",
	"./fishes/actual/napoleonfish.png": "3ea4",
	"./fishes/actual/neontetra.png": "3ce4",
	"./fishes/actual/nibblefish.png": "d598",
	"./fishes/actual/oarfish.png": "9b2f",
	"./fishes/actual/oceansunfish.png": "1bf9",
	"./fishes/actual/oliveflounder.png": "c265",
	"./fishes/actual/palechub.png": "c619",
	"./fishes/actual/pike.png": "6a0c",
	"./fishes/actual/pondsmelt.png": "9337",
	"./fishes/actual/popeyedgoldfish.png": "d85a",
	"./fishes/actual/pufferfish.png": "cd29",
	"./fishes/actual/rainbowfish.png": "6992",
	"./fishes/actual/ranchugoldfish.png": "133d",
	"./fishes/actual/ray.png": "72e3",
	"./fishes/actual/redsnapper.png": "35d7",
	"./fishes/actual/ribboneel.png": "51c8",
	"./fishes/actual/saddledbichir.png": "6454",
	"./fishes/actual/salmon.png": "a701",
	"./fishes/actual/seabass.png": "6548",
	"./fishes/actual/seabutterfly.png": "c387",
	"./fishes/actual/seahorse.png": "fc7c",
	"./fishes/actual/snappingturtle.png": "fe95",
	"./fishes/actual/softshelledturtle.png": "fd25",
	"./fishes/actual/squid.png": "99f9",
	"./fishes/actual/stringfish.png": "9ee5",
	"./fishes/actual/sturgeon.png": "ccf2",
	"./fishes/actual/suckerfish.png": "6a18",
	"./fishes/actual/surgeonfish.png": "677d",
	"./fishes/actual/sweetfish.png": "38e5",
	"./fishes/actual/tadpole.png": "29f0",
	"./fishes/actual/tilapia.png": "e638",
	"./fishes/actual/tuna.png": "3fc7",
	"./fishes/actual/yellowperch.png": "47e5",
	"./fishes/actual/zebraturkeyfish.png": "77ca",
	"./fishes/icon/anchovy.png": "a606",
	"./fishes/icon/angelfish.png": "efbb",
	"./fishes/icon/arapaima.png": "780a",
	"./fishes/icon/arowana.png": "b002",
	"./fishes/icon/barredknifejaw.png": "8d31",
	"./fishes/icon/barreleye.png": "1294",
	"./fishes/icon/betta.png": "274e",
	"./fishes/icon/bitterling.png": "07ea",
	"./fishes/icon/blackbass.png": "5b1c",
	"./fishes/icon/blowfish.png": "a061",
	"./fishes/icon/bluegill.png": "736a",
	"./fishes/icon/bluemarlin.png": "b186",
	"./fishes/icon/butterflyfish.png": "0b5b",
	"./fishes/icon/carp.png": "a2cc",
	"./fishes/icon/catfish.png": "d900",
	"./fishes/icon/char.png": "bbd2",
	"./fishes/icon/cherrysalmon.png": "6476",
	"./fishes/icon/clownfish.png": "8b10",
	"./fishes/icon/coelacanth.png": "83b0",
	"./fishes/icon/crawfish.png": "d651",
	"./fishes/icon/cruciancarp.png": "a2fc",
	"./fishes/icon/dab.png": "aeee",
	"./fishes/icon/dace.png": "b62e",
	"./fishes/icon/dorado.png": "1999",
	"./fishes/icon/footballfish.png": "4142",
	"./fishes/icon/freshwatergoby.png": "6251",
	"./fishes/icon/frog.png": "98d7",
	"./fishes/icon/gar.png": "0b81",
	"./fishes/icon/giantsnakehead.png": "3fc1",
	"./fishes/icon/gianttrevally.png": "930c",
	"./fishes/icon/goldentrout.png": "f42c",
	"./fishes/icon/goldfish.png": "b81e",
	"./fishes/icon/greatwhiteshark.png": "1340",
	"./fishes/icon/guppy.png": "27b3",
	"./fishes/icon/hammerheadshark.png": "1d7f",
	"./fishes/icon/horsemackerel.png": "be46",
	"./fishes/icon/killifish.png": "ecbc",
	"./fishes/icon/kingsalmon.png": "7dee",
	"./fishes/icon/koi.png": "7a2e",
	"./fishes/icon/loach.png": "82f8",
	"./fishes/icon/mahimahi.png": "35c9",
	"./fishes/icon/mittencrab.png": "30a8",
	"./fishes/icon/morayeel.png": "6573",
	"./fishes/icon/napoleonfish.png": "4955",
	"./fishes/icon/neontetra.png": "753e",
	"./fishes/icon/nibblefish.png": "5750",
	"./fishes/icon/oarfish.png": "e98b",
	"./fishes/icon/oceansunfish.png": "0972",
	"./fishes/icon/oliveflounder.png": "90a0",
	"./fishes/icon/palechub.png": "bb78",
	"./fishes/icon/pike.png": "6082",
	"./fishes/icon/piranha.png": "47b9",
	"./fishes/icon/pondsmelt.png": "5bcd",
	"./fishes/icon/popeyedgoldfish.png": "fbd6",
	"./fishes/icon/pufferfish.png": "be8b",
	"./fishes/icon/rainbowfish.png": "c05b",
	"./fishes/icon/ranchugoldfish.png": "ece5",
	"./fishes/icon/ray.png": "bd29",
	"./fishes/icon/redsnapper.png": "e7b8",
	"./fishes/icon/ribboneel.png": "3f67",
	"./fishes/icon/saddledbichir.png": "7a08",
	"./fishes/icon/salmon.png": "64e9",
	"./fishes/icon/sawshark.png": "f3fe",
	"./fishes/icon/seabass.png": "96db",
	"./fishes/icon/seabutterfly.png": "7e2c",
	"./fishes/icon/seahorse.png": "6cef",
	"./fishes/icon/snappingturtle.png": "d893",
	"./fishes/icon/softshelledturtle.png": "34ee",
	"./fishes/icon/squid.png": "cf05",
	"./fishes/icon/stringfish.png": "46b8",
	"./fishes/icon/sturgeon.png": "7ef4",
	"./fishes/icon/suckerfish.png": "08c2",
	"./fishes/icon/surgeonfish.png": "3073",
	"./fishes/icon/sweetfish.png": "31ab",
	"./fishes/icon/tadpole.png": "85cc",
	"./fishes/icon/tilapia.png": "5efc",
	"./fishes/icon/tuna.png": "43b0",
	"./fishes/icon/whaleshark.png": "ae8c",
	"./fishes/icon/yellowperch.png": "d7a1",
	"./fishes/icon/zebraturkeyfish.png": "da06",
	"./screenshot-list/bugs.png": "3ee5",
	"./screenshot-list/deepSeaCreatures.png": "e1c4",
	"./screenshot-list/fishes.png": "23c2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";